import { every } from "lodash";

export const hasAncestorNode = (el, ancestorNode) => {
  while (el && el !== ancestorNode) {
    el = el.parentElement;
  }
  return el === ancestorNode;
};

export const findAncestorOfClass = (el, className) => {
  while (el && !el.classList.contains(className)) {
    el = el.parentElement;
  }
  return el;
};

export const findAncestorWithId = (el, id) => {
  while (el && el.id !== id) {
    el = el.parentElement;
  }
  return el;
};
export const hasAncestorWithId = (el, id) => findAncestorWithId(el, id) !== null;

const hasAncestorOfClass = (el, className) => findAncestorOfClass(el, className) !== null;

export const hasAncestorOfAnyClasses = (el, classesArray) =>
  classesArray.find(className => findAncestorOfClass(el, className) !== null) !== undefined;

const hasAllClasses = (el, classNames) => {
  return every(classNames, n => el.classList.contains(n));
};

export const hasAncestorWithClasses = (el, classNames) => {
  while (el && !hasAllClasses(el, classNames)) {
    el = el.parentElement;
  }
  return el !== null;
};

export default hasAncestorOfClass;
